import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import HeroImage from '../components/Hero/HeroImage'
import HomeTemplate from '../templates'
import useFaqItems from '../hooks/useFaqItems'
import useProducts from '../hooks/useProducts'
import useChartInfo from '../hooks/useChartInfo'
import useChartLevels from '../hooks/useChartLevels'
import useProductsImages from '../hooks/useProductsImage'
import messages from '../../locales/pt-br/messages'
import Layout from '../layouts'
import useFooterLinks from '../hooks/useFooterLinks'
import locationPropTypes from '../types/locationPropTypes'
import LangKeyContext from '../contexts/LangKeyContext'
import pageContextPropTypes from '../types/pageContextPropTypes'
import useBenefitContent from '../hooks/useBenefitContent'
import useCatalog from '../hooks/useCatalog'
import useOnlineChartInfo from '../hooks/useOnlineChartInfo'
import useDataLayer from '../hooks/useDataLayer'

const IndexPage = ({ langKey, location, i18nMessages, ctaOnClick, isEloThemeActive, isChartNoProductActive,...props}) => {
  const FAQData = useFaqItems()
  const products = useProducts()
  const catalog = useCatalog()
  const productsImage = useProductsImages()
  const chartLevels = useChartLevels()
  const chartInfo = useChartInfo()
  const onlineChartInfo = useOnlineChartInfo()
  const footerLinks = useFooterLinks()
  const benefits = useBenefitContent()
  const dataLayer = useDataLayer()
  const country2Prefix = location.pathname?.split('/')[1]?.toUpperCase()
  if (typeof window !== 'undefined') {
    localStorage.setItem('countryPrefix', country2Prefix)
  }
  const socialLinks = footerLinks[langKey].edges.filter(
    item => item.node.frontmatter.linkType === 'social'
  )
  const phoneLinks = footerLinks[langKey].edges.filter(
    item => item.node.frontmatter.linkType === 'phone'
  )
  const helpLinks = footerLinks[langKey].edges.filter(
    item => item.node.frontmatter.linkType === 'help'
  )

  useEffect(() => {
    dataLayer.push({ event: 'load_info', country: country2Prefix.toLowerCase() })
  }, [])

  return (
    <LangKeyContext.Provider value={langKey}>
      <Layout location={location} i18nMessages={i18nMessages} langKey={langKey} isEloThemeActive={isEloThemeActive}>
        <HomeTemplate
          FAQData={FAQData[langKey]}
          HeroProps={{
            heroImage: <HeroImage lang={langKey} />,
          }}
          benefitsData={benefits[langKey]}
          productsData={products[langKey]}
          catalogData={catalog[langKey]}
          productsImage={productsImage[langKey].publicURL}
          chartLevelsData={chartLevels[langKey]}
          chartInfoData={chartInfo[langKey]}
          onlineChartInfoData={onlineChartInfo[langKey]}
          socialLinks={socialLinks}
          phoneLinks={phoneLinks}
          helpLinks={helpLinks}
          langKey={langKey}
          ctaOnClick={ctaOnClick}
          isEloThemeActive={isEloThemeActive || false}
          isChartNoProductActive={isChartNoProductActive || false}
          {...props}
        />
      </Layout>
    </LangKeyContext.Provider>
  )
}

export default IndexPage

IndexPage.defaultProps = {
  langKey: 'pt_BR',
  i18nMessages: messages
}

IndexPage.propTypes = {
  langKey: PropTypes.string,
  location: PropTypes.shape(locationPropTypes),
  i18nMessages: PropTypes.object,
  pageContext: PropTypes.shape(pageContextPropTypes),
  ctaOnClick: PropTypes.func
}
